import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AuthenticationService } from '@app/_services/authentication.service';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { ListModelStateInitial } from '@app/_store/list-model/list-model.actions';
import { ListComponentStateInitial } from '@app/_store/list-component/list-component.actions';

@Component({
  selector: 'app-log-out-modal',
  templateUrl: './log-out-modal.component.html',
  styleUrls: ['./log-out-modal.component.scss']
})
export class LogOutModalComponent implements OnInit {

  public multipleActiveTenants: boolean;

  constructor(
    public modal: BsModalRef,
    private authenticationService: AuthenticationService,
    private router: Router,
    private store: Store
  ) { }

  ngOnInit() {
    const tenantCount = this.authenticationService.getTenantSessionCount();
    if (tenantCount > 1)
      this.multipleActiveTenants = true;
    else 
      this.multipleActiveTenants = false;
   }

  logOut(allActiveSessions: boolean) {
    this.store.dispatch(new ListModelStateInitial);
    this.store.dispatch(new ListComponentStateInitial);

    this.modal.hide();
    setTimeout(() => {
      if (allActiveSessions)
        this.authenticationService.logoutAllSessions();
      else
        this.authenticationService.logout();
        
      this.router.navigate(['/login']);
    }, 250);
  }

}
